module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-07.d4cd765e.png";